import { render, staticRenderFns } from "./EditScoring.vue?vue&type=template&id=50c60d21&scoped=true&"
import script from "./EditScoring.vue?vue&type=script&lang=js&"
export * from "./EditScoring.vue?vue&type=script&lang=js&"
import style0 from "./EditScoring.vue?vue&type=style&index=0&id=50c60d21&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c60d21",
  null
  
)

export default component.exports